const isPropertiesSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.PropertiesSection => {
  return s.sectionType === 'Properties';
};

export default isPropertiesSection;
